// ABOUTME: Keys of the node assignment columns (owner, dealership, client) of the DataTableWrapper.
// ABOUTME: Kept apart from the wrapper so consumers can whitelist them without importing the grid.

// Node assignment columns (`system-assigned-<key>`), rendered when the object schema enables
// node ownership. Consumers narrow them through the wrapper's `assignmentColumns` prop.
export const ASSIGNMENT_COLUMN_KEYS = ['owner', 'dealership', 'client'] as const;
export type AssignmentColumnKey = (typeof ASSIGNMENT_COLUMN_KEYS)[number];
